<template lang="pug">
  div
    v-btn.blue(@click="activarAlerta", depressed, round, dark) 
      v-icon(left) edit
      | alerta
    app-alerta(ref="alerta", aceptar="OK", :persistent="true" :actions="true", color="primary", :dark="true", titulo="titititi", @cerrando="cerrando", :toolbar="true", @aceptando="aceptando")
      p hola mundo
</template>
<script>
export default {
  methods: {
    activarAlerta () {
      this.$refs.alerta.activo = true
    },
    cerrando () {
      console.log('cerrando')
    },
    aceptando () {
      console.log('aceptando')
    },
  }
}
</script>

